import apiCars from '../apis/Cars'


export async function selectTypesCars() {
  try {
    const response = await apiCars.getCarsType();
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function selectBrandsCars() {
  try {
    const response = await apiCars.getCarsBrands();
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function selectModelsCars(carBrandId) {
  try {
    const params = {
      carBrandId: carBrandId,
    };
    
    const response = await apiCars.postCarsModels(params);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}